import { useSelector } from "react-redux";
import {
  getCurrentFrameIndex,
  getCurrentStep,
  getKeyFrameSequentialIndices,
  getHotspotPathState,
} from "../../redux/selectors";
import { steps } from "../../util/constants";
import Marker from "./Marker";
import { hotspotPathStates } from "../../redux/ui/ui";

export function MarkerContainer() {
  const currentStep = useSelector(getCurrentStep);
  const keyFrames = useSelector(getKeyFrameSequentialIndices);
  const currentFrame = useSelector(getCurrentFrameIndex);
  const markerFrames = keyFrames.length > 3 ? keyFrames.slice(0, 3) : keyFrames;
  const hotspotPathState = useSelector(getHotspotPathState);
  const showAll = hotspotPathState === hotspotPathStates.demo;
  return currentStep === steps.configureLocations
    ? markerFrames.map((frame, index) =>
        currentFrame === frame || showAll ? (
          <Marker frame={frame} number={index + 1} key={index} />
        ) : null
      )
    : null;
}
